import { Flex, FlexProps } from "@chakra-ui/react";
import { ReactNode } from "react";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { OnlyProductionEnvironment } from "@/environment/components/EnvironmentCallouts";
import LinearIntegrationForm from "@/integration/components/linear/LinearIntegrationForm";

type LinearConnectionGuardProps = FlexProps & {
  productionOnly?: boolean;
  children?: ReactNode;
};

export default function LinearConnectionGuard({
  productionOnly = false,
  children,
  ...rest
}: LinearConnectionGuardProps) {
  const { env, org } = useEnvironment();

  if (productionOnly && !env.isProduction) {
    return <OnlyProductionEnvironment entity="linear configuration" />;
  }

  return (
    <Flex direction="column" gap={8} {...rest}>
      {!org.integrations.linear && <LinearIntegrationForm isGuard />}
      {children}
    </Flex>
  );
}
